import * as yup from "yup";
import { LICENSED } from "../Constants";
export const userSchema = yup.object().shape({
    email: yup.string().email("Please enter a valid email address").required("Email is required"),
    password: yup.string().required("Password is required"),
})
export const newUserSchema = yup.object().shape({
    firstName: yup.string().required("First name is a required field"),
    lastName: yup.string().required("Last name is a required field"),
    email: yup.string().email("Please enter a valid email id").required("Email is a required field"),
    password: yup.string().required("Password is a required field"),
    terms: yup.boolean().test({
        test(value, ctx) {
            if (!value) {
              return ctx.createError({ message: "Please accept the terms and conditions to proceed" })
            }
            return true
          }
    }),
})
export const newLitigationFunderSchema = yup.object().shape({
    email: yup.string().email("Please enter a valid email id.").required("Email is a required field."),
    lawFirmLink: yup.string().required("Entity website url is a required field."),
    firstName: yup.string().required("Entity name is a required field."),
    password: yup.string().required("Password is a required field."),
    terms: yup.boolean().test({
        test(value, ctx) {
            if (!value) {
              return ctx.createError({ message: "Please accept the terms and conditions to proceed" })
            }
            return true
          }
    }),
})

export const clientInfoSchema = yup.object().shape({
  firstName: yup.string().required("First name is a required field"),
  lastName: yup.string().required("Last name is a required field"),
  email: yup.string().email("Please enter a valid email id").required("Email is a required field"),
  age: yup.number("Please enter a valid age details"),
  phoneNumber: yup.number("Please enter a valid phone number"),
  city: yup.string(),
  state: yup.string()
});

export const professionalInfoSchema = yup.object({
  firstName: yup.string().required("First name is a required field"),
  lastName: yup.string().required("Last name is a required field"),
  email: yup.string().email("Please enter a valid email id").required("Email is a required field"),
  company: yup.string().required("Please enter name of the law firm."),
  phoneNumber: yup.number("Please enter a valid phone number"),
  experience: yup.number(),
  legalType: yup.string().required("Designation is a required field"),
  linkedin:  yup.string(),
  lawFirmLink : yup.string().required("Please enter law firm link."),
  casePref: yup.array(),
  statePref: yup.array(),

  });

  export const litigationFunderInfoSchema = yup.object({
    firstName: yup.string().required("First name is a required field"),
    lastName: yup.string().required("Last name is a required field"),
    email: yup.string().email("Please enter a valid email id").required("Email is a required field"),
    company: yup.string().required("The name of the litigation funder entity is a required field."),
    experience: yup.number(),
    lawFirmLink : yup.string().required("The website link of the litigation funder is a required field."),
    casePref: yup.array().required("At least one case preference is required."),
    statePref: yup.array().required("At least one state preference is required."),
    authorizedConsent: yup.boolean().test({
        test(value, ctx) {
            if (!value) {
              return ctx.createError({ message: "Please confirm that you are authorized to create an account on www.quickcasereview.com on behalf of the litigation funder." })
            }
            return true
          }
    }),
  });

  export const lawFirmInfoSchema = yup.object({
    firstName: yup.string().required("First name is a required field"),
    lastName: yup.string().required("Last name is a required field"),
    company: yup.string().required("The name of the law firm is a required field."),
    lawFirmLink : yup.string().required("The website link of the law firm is a required field."),
    phoneNumber: yup.number("Please enter a valid phone number"),
    lawFirmId: yup.string(),
  });
